import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { logout } from "../../utils/auth";
import { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../utils/api";
import { toast } from "react-toastify";
import Loader from "../../Component/Loader/Loader";
import Swal from "sweetalert2";

const KnowledgeBase = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const isEditMode = Boolean(id);
    const [knowledgeCategory, setKnowledgeCategory] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [isLoader, setIsLoader] = useState<any>(true);

    const [summary, setSummaryData] = useState({
        total_categories: 0,
        total_published: 0,
        total_draft: 0
    });

    const fetchKnowledgeCategoryList = async () => {
        setLoading(true);
        try {
            const response = await getRequest(`/knowledge/knowledge-category-list`);

            if (response.status === "success") {

                const categories = response.data;

                const totalPublished = categories.filter(
                    (item: any) => item.cat_publish_type == 1
                ).length;

                const totalDraft = categories.filter(
                    (item: any) => item.cat_publish_type == 0
                ).length;

                setKnowledgeCategory(categories);

                setSummaryData({
                    total_categories: categories.length,
                    total_published: totalPublished,
                    total_draft: totalDraft
                });

            } else if (response.status == 'session_expired') {
                logout()
            } else {
                toast.error(response.message);
            }

        } catch (error) {
            console.error("Error fetching plans:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchKnowledgeCategoryList();
    }, []);

    const deleteUser = async (item: any) => {
        const result = await Swal.fire({
            title: 'Are you sure want to permanent delete?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            icon: 'warning',
            customClass: {
                title: "custom-swal-title",
                popup: "custom-swal-popup",
                confirmButton: "custom-swal-button",
                cancelButton: "custom-swal-cancel"
            }
        });

        if (result.isConfirmed) {
            setIsLoader(true);
            try {
                const payload = {
                    _id: item?._id,
                };
                const response = await postRequest('/knowledge/deleteKnowledgeCategory', payload);
                if (response.status === 'success') {
                    fetchKnowledgeCategoryList();
                    Swal.fire({
                        title: response.message,
                        icon: 'success',
                        customClass: {
                            popup: "custom-swal-popup"
                        }
                    });
                } else if (response.status === 'session_expired') {
                    setIsLoader(false);
                    logout()
                } else {
                    setIsLoader(false);
                    Swal.fire({
                        title: response.message,
                        icon: 'error',
                        customClass: {
                            popup: "custom-swal-popup"
                        }
                    });
                }
            } catch (error: any) {
                setIsLoader(false);
                toast.error(error.message);
            } finally {
                setIsLoader(false);
            }
        }
    };

    return (
        <>
            {isLoader || loading && (<Loader />)}
            <div className="hk-pg-wrapper">
                <div className="hk-pg-body py-0">
                    <div className="page-wrap">
                        <div className="page-content ps-0">
                            <div className="page-detail-wrap">
                                <header className="page-header">
                                    <div>
                                        <div className="page-title">
                                            <h2 className="mb-0">Knowledge Base</h2>
                                        </div>
                                        <p className="text-muted mb-0">Manage your documentation — categories, articles, and visibility.</p>
                                    </div>
                                    <div className="page-options-wrap">
                                        <Link to="/add-knowledge-category" className="btn btn-dark btn-rounded">
                                            <span>
                                                <span className="icon"><i className="ri-add-line bticon"></i></span>
                                                <span>New Category</span>
                                            </span>
                                        </Link>
                                        <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                                            href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                                            data-bs-original-title="Collapse">
                                            <span className="btn-icon-wrap">
                                                <span className="feather-icon"><i className="ri-arrow-up-s-line ri-lg"></i></span>
                                                <span className="feather-icon d-none"><i className="ri-arrow-down-s-line ri-lg"></i></span>
                                            </span>
                                        </a>
                                    </div>
                                </header>
                                <div className="page-body">
                                    <div data-simplebar className="nicescroll-bar">
                                        <div className="container-fluid">
                                            <div className="row g-3">
                                                <div className="col-lg-4">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between"><div>
                                                                <p className="mb-1 text-muted">Total Categories</p>
                                                                <h6 className="h2">{summary.total_categories}</h6>
                                                            </div>
                                                                <div className="flex-shrink-0">
                                                                    <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                                                        <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-center gap-2 mt-1">
                                                                <span className="fs-12 text-muted">Knowledge base sections</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between"><div>
                                                                <p className="mb-1 text-muted">Published</p>
                                                                <h6 className="h2">{summary.total_published}</h6>
                                                            </div>
                                                                <div className="flex-shrink-0">
                                                                    <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                                                        <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-center gap-2 mt-1">
                                                                <span className="fs-12 text-muted">Visible to customers</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between"><div>
                                                                <p className="mb-1 text-muted">Total Draft</p>
                                                                <h6 className="h2">{summary.total_draft}</h6>
                                                            </div>
                                                                <div className="flex-shrink-0">
                                                                    <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                                                        <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-center gap-2 mt-1">
                                                                <span className="fs-12 text-muted">Not Visible to customers</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            {knowledgeCategory.length > 0 && (
                                                <div className="row g-3">
                                                    {knowledgeCategory.map((item, index) => (
                                                        <div className="col-lg-4" key={item.cat_id}>
                                                            <div className="card card-animate">
                                                                <div className="card-body">
                                                                    <div className="d-flex justify-content-between">
                                                                        <div>
                                                                            <div className="avatar avatar-sm avatar-icon avatar-soft-light avatar-smmm">
                                                                                <span className="initial-wrap">
                                                                                    <i className="ri-article-line"></i>
                                                                                </span>
                                                                            </div>

                                                                            <div className="mt-2">
                                                                                <h6 className="h5 mb-1">
                                                                                    {item.cat_title}
                                                                                </h6>

                                                                                <p className="mb-0 fs-12 text-muted eclips-01">
                                                                                    {item.cat_description}
                                                                                </p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="flex-shrink-0">
                                                                            {item.cat_publish_type === 1 ?
                                                                                <span className="badge bg-success d-flex align-items-center gap-1">
                                                                                    <i className="ri-eye-line"></i> Live
                                                                                </span>
                                                                                :
                                                                                <span className="badge bg-warning d-flex align-items-center gap-1">
                                                                                    <i className="ri-eye-line"></i> Draft
                                                                                </span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="card-footer">
                                                                    <div style={{ width: '100%' }}>
                                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                                            <div className="fs-12 text-muted d-flex align-items-center gap-1">
                                                                                <i className="ri-article-line"></i> 0 articles
                                                                            </div>

                                                                            <div className="fs-12 text-muted">
                                                                                Order #{item.cat_sort_order || 0}
                                                                            </div>
                                                                        </div>

                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div className="flex-grow-1 overflow-hidden">
                                                                                <button
                                                                                    onClick={(e) => navigate('/knowledge-base-articals/' + item._id)}
                                                                                    type="button"
                                                                                    className="btn btn-block btn-sm btn-flush-dark btn-border flush-soft-hover"
                                                                                >
                                                                                    <span>
                                                                                        <span className="icon">
                                                                                            <i className="ri-bookmark-line"></i>
                                                                                        </span>
                                                                                        <span>Manage</span>
                                                                                    </span>
                                                                                </button>
                                                                            </div>

                                                                            <div className="flex-shrink-0">
                                                                                <button
                                                                                    onClick={(e) => deleteUser(item)}
                                                                                    type="button"
                                                                                    className="btn btn-icon btn-sm btn-flush-danger btn-border flush-soft-hover"
                                                                                >
                                                                                    <span className="icon">
                                                                                        <i className="ri-delete-bin-6-line"></i>
                                                                                    </span>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
export default KnowledgeBase